var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCadmusLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6103 3.49272C14.6465 3.54559 14.6294 3.61779 14.574 3.64981L9.7177 6.45359C9.68333 6.47343 9.64097 6.47343 9.60659 6.45359L8.88359 6.03616C7.28928 5.11569 5.25065 5.66194 4.33017 7.25624C3.89023 8.01824 3.78534 8.88174 3.9698 9.67615C3.98109 9.7248 3.96001 9.77551 3.91676 9.80048L2.13478 10.8293C2.03633 10.8861 2.07666 11.0366 2.19034 11.0366L4.58569 11.0366C4.61898 11.0366 4.65044 11.0516 4.67195 11.077C4.91357 11.3625 5.20773 11.6119 5.55025 11.8097L8.20109 13.3401C9.69711 14.2039 11.3971 14.3943 12.9502 14.0056C13.0663 13.9765 13.1492 14.124 13.0565 14.1997C11.6783 15.325 9.91799 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C10.7465 0 13.1698 1.38404 14.6103 3.49272Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5744 1.43727C13.4028 2.01596 14.1166 2.74749 14.6747 3.59096L9.6612 6.48553L9.66016 6.48493L12.5744 1.43727Z",
    fill: "url(#paint0_linear_1295_2022)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1295_2022",
    x1: 9.66433,
    y1: 2.22227,
    x2: 9.66433,
    y2: 8.44492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadmusLight);
export default __webpack_public_path__ + "static/media/cadmus_light.f43f9aacff55ca49a11093f264bc25d6.svg";
export { ForwardRef as ReactComponent };